import { call, takeEvery, takeLatest } from "redux-saga/effects";
import {
  BINLOCATION_ADD,
  INVENTORY_CREATE,
  STOCK_TRANSFER_BATCH,
  STOCK_TRANSFER_CREATE,
  STOCK_TRANSFER_EDIT,
  STOCK_TRANSFER_DECLINE,
  STOCK_TRANSFER_TABLE,
  STOCK_TRANSFER_VIEW,
  VOID_STOCK_TRANSFER,
  VOID_STOCK_TRANSFER_BATCH,
  VOID_STOCK_TRANSFER_ITEM,
  WAREHOUSE_LIST,
  WAREHOUSE_GET_ID,
  WAREHOUSE_LIST_WITH_CAPACITY,
  WAREHOUSE_BIN_LIST,
  WAREHOUSE_BIN_GENERATE,
  WAREHOUSE_BIN_ADD,
  WAREHOUSE_BIN_UPDATE,
  WAREHOUSE_BIN_DELETE,
  WAREHOUSE_BIN_DEFAULT_ITEMS_ADD,
  WAREHOUSE_BIN_DEFAULT_ITEMS_LIST,
  WAREHOUSE_BIN_SET_DEFAULT,
  WAREHOUSE_BIN_ITEMS_LIST,
  WAREHOUSE_EXPIRED_ITEMS_LIST,
} from "../types";
import {
  binlocationAddApi,
  inventoryCreateApi,
  stockTransferBatchApi,
  stockTransferCreateApi,
  stockTransferEditApi,
  stockTransferDeclineApi,
  stockTransferTableApi,
  stockTransferViewApi,
  voidStockTransferApi,
  voidStockTransferItemApi,
  warehouseListApi,
  warehouseGetIdApi,
  warehouseListWithCapacityApi,
  warehouseBinListApi,
  warehouseBinGenerateApi,
  warehouseBinAddApi,
  warehouseBinUpdateApi,
  warehouseBinDeleteApi,
  warehouseBinDefaultItemsAddApi,
  warehouseBinDefaultItemsListApi,
  warehouseBinSetDefaultApi,
  warehouseBinItemsListApi,
  warehouseExpiredItemsListApi,
} from "../apis/inventory-api";

export function* inventoryCreateWorker(action) {
  try {
    const res = yield call(inventoryCreateApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* binlocationAddWorker(action) {
  try {
    const res = yield call(binlocationAddApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseListWorker(action) {
  try {
    const res = yield call(warehouseListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* warehouseGetIdWorker(action) {
  try {
    const res = yield call(warehouseGetIdApi);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseListWithCapacityWorker(action) {
  try {
    const res = yield call(warehouseListWithCapacityApi);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinListWorker(action) {
  try {
    const res = yield call(warehouseBinListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinGenerateWorker(action) {
  try {
    const res = yield call(warehouseBinGenerateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinAddWorker(action) {
  try {
    const res = yield call(warehouseBinAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinUpdateWorker(action) {
  try {
    const res = yield call(warehouseBinUpdateApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinDeleteWorker(action) {
  try {
    const res = yield call(warehouseBinDeleteApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinDefaultItemsAddWorker(action) {
  try {
    const res = yield call(warehouseBinDefaultItemsAddApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinDefaultItemsListWorker(action) {
  try {
    const res = yield call(warehouseBinDefaultItemsListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseExpiredItemsListWorker(action) {
  try {
    const res = yield call(warehouseExpiredItemsListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinItemsListWorker(action) {
  try {
    const res = yield call(warehouseBinItemsListApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* warehouseBinSetDefaultWorker(action) {
  try {
    const res = yield call(warehouseBinSetDefaultApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockTransferCreateWorker(action) {
  try {
    const res = yield call(stockTransferCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockTransferEditWorker(action) {
  try {
    const res = yield call(stockTransferEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockTransferDeclineWorker(action) {
  try {
    const res = yield call(stockTransferDeclineApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockTransferTableWorker(action) {
  try {
    const res = yield call(stockTransferTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockTransferViewWorker(action) {
  try {
    const res = yield call(stockTransferViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockTransferbatchWorker(action) {
  try {
    const res = yield call(stockTransferBatchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* voidStockTransferWorker(action) {
  try {
    const res = yield call(voidStockTransferApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* voidStockTransferItemWorker(action) {
  try {
    const res = yield call(voidStockTransferItemApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* voidStockTransferItemWatcher() {
  yield takeLatest(VOID_STOCK_TRANSFER_ITEM, voidStockTransferItemWorker);
}
export function* voidStockTransferWatcher() {
  yield takeLatest(VOID_STOCK_TRANSFER, voidStockTransferWorker);
}
export function* stockTransferbatchWatcher() {
  yield takeLatest(STOCK_TRANSFER_BATCH, stockTransferbatchWorker);
}
export function* stockTransferViewWatcher() {
  yield takeLatest(STOCK_TRANSFER_VIEW, stockTransferViewWorker);
}
export function* stockTransferTableWatcher() {
  yield takeLatest(STOCK_TRANSFER_TABLE, stockTransferTableWorker);
}
export function* stockTransferCreateWatcher() {
  // takeEvery: a multi-store transfer dispatches several CREATE actions back to
  // back, and takeLatest would cancel every one but the last before its
  // onSuccess/onError ever fires.
  yield takeEvery(STOCK_TRANSFER_CREATE, stockTransferCreateWorker);
}
export function* stockTransferEditWatcher() {
  yield takeEvery(STOCK_TRANSFER_EDIT, stockTransferEditWorker);
  yield takeEvery(STOCK_TRANSFER_DECLINE, stockTransferDeclineWorker);
}
export function* inventoryCreateWatcher() {
  yield takeLatest(INVENTORY_CREATE, inventoryCreateWorker);
}

export function* binlocationAddWatcher() {
  yield takeLatest(BINLOCATION_ADD, binlocationAddWorker);
}

export function* warehouseListWatcher() {
  yield takeLatest(WAREHOUSE_LIST, warehouseListWorker);
}

export function* warehouseGetIdWatcher() {
  yield takeLatest(WAREHOUSE_GET_ID, warehouseGetIdWorker);
}

export function* warehouseListWithCapacityWatcher() {
  yield takeLatest(WAREHOUSE_LIST_WITH_CAPACITY, warehouseListWithCapacityWorker);
}

export function* warehouseBinListWatcher() {
  yield takeLatest(WAREHOUSE_BIN_LIST, warehouseBinListWorker);
}

export function* warehouseBinGenerateWatcher() {
  yield takeLatest(WAREHOUSE_BIN_GENERATE, warehouseBinGenerateWorker);
}

export function* warehouseBinAddWatcher() {
  yield takeLatest(WAREHOUSE_BIN_ADD, warehouseBinAddWorker);
}

export function* warehouseBinUpdateWatcher() {
  yield takeLatest(WAREHOUSE_BIN_UPDATE, warehouseBinUpdateWorker);
}

export function* warehouseBinDeleteWatcher() {
  yield takeLatest(WAREHOUSE_BIN_DELETE, warehouseBinDeleteWorker);
}

export function* warehouseBinDefaultItemsAddWatcher() {
  yield takeLatest(
    WAREHOUSE_BIN_DEFAULT_ITEMS_ADD,
    warehouseBinDefaultItemsAddWorker
  );
}

export function* warehouseBinDefaultItemsListWatcher() {
  yield takeLatest(
    WAREHOUSE_BIN_DEFAULT_ITEMS_LIST,
    warehouseBinDefaultItemsListWorker
  );
}

export function* warehouseBinSetDefaultWatcher() {
  yield takeLatest(WAREHOUSE_BIN_SET_DEFAULT, warehouseBinSetDefaultWorker);
}

export function* warehouseBinItemsListWatcher() {
  yield takeLatest(WAREHOUSE_BIN_ITEMS_LIST, warehouseBinItemsListWorker);
}

export function* warehouseExpiredItemsListWatcher() {
  yield takeLatest(WAREHOUSE_EXPIRED_ITEMS_LIST, warehouseExpiredItemsListWorker);
}
